import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Upload = (props) => {
  let inputClass = 'c-personalizer-group__upload c-upload__input'

  function handleRemove(e) {
    props.onRemoveFile()
  }

  return (
    <div className="c-personalizer-group c-personalizer-group--upload c-upload">
      <div className="c-upload__container">
        
        <div className="c-upload__content">
          { props.value && props.fileName ? (
            <span>{props.fileName}</span>
          ) : (
            <span>Selecteer een bestand</span>
          ) }
        </div>
        
        <div className="c-upload__button">Uploaden</div>
        <input type="file" className={inputClass} accept=".doc,.docx,.pdf,.jpg,.png" {...props} />
      </div>

      { props.value ? (
        <div className="c-personalizer-upload__remove" onClick={handleRemove}>
          <svg class="c-icon c-personalizer-upload__icon">
            <use href="#cross-dicht" xlinkHref="#cross-dicht"></use>
          </svg>
          <span>Verwijder</span>
        </div>
      ) : null }
      
      <p class="c-personalizer-group__error-message">{ props.error }</p>
    </div>
  )
}

export default Upload



// WEBPACK FOOTER //
// ./src/js/personalizer/components/input/Upload.js